export function insertAtCursor(
  input: HTMLInputElement | HTMLTextAreaElement,
  token: string,
  setValue: (v: string) => void,
  maxLength?: number,
) {
  const start = input.selectionStart ?? input.value.length;
  const end = input.selectionEnd ?? input.value.length;
  let next = input.value.slice(0, start) + token + input.value.slice(end);
  if (maxLength !== undefined && next.length > maxLength) next = next.slice(0, maxLength);
  setValue(next);
  requestAnimationFrame(() => {
    input.focus();
    input.setSelectionRange(start + token.length, start + token.length);
  });
}
